/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { sendSegment, subscribeSegment, userSubscribeSegment } from './common-websocket-topic-url-constants';
import {
  deliveryInboxAddedSegment,
  deliveryInboxSegment,
  deliveryInboxUpdatedSegment,
  deliveryOutboxSegment,
  deliveryOutboxUpdatedSegment,
  offerAddedSegment,
  offerChatIncomingSegment,
  offerChatReadMessageSegment,
  offerChatSegment,
  offerChatSendMessageSegment,
  offerChatStatusSegment,
  offerChatStatusUpdateSegment,
  offerRequestSegment,
  offerRequestStatusSegment,
  offerRequestUpdatedSegment,
  offerSegment,
  orderSegment,
  orderStatusSegment,
  orderUpdatedSegment,
  shipmentSplitAddedSegment,
  shipmentSplitOfferSegment,
  shipmentSplitSegment,
  shipmentTrackingClosedSegment,
  shipmentTrackingGeneratedSegment,
  shipmentTrackingInvoiceSegment,
  shipmentTrackingOrderSegment,
  shipmentTrackingOrderStatusAcceptedSegment,
  shipmentTrackingOrderStatusCompletedSegment,
  shipmentTrackingOrderStatusDocumentsReceivedSegment,
  shipmentTrackingOrderStatusInProgressSegment,
  shipmentTrackingOrderStatusInTransitSegment,
  shipmentTrackingOrderStatusUpdatedSegment,
  shipmentTrackingSavedSegment,
  shipmentTrackingSegment,
  shipmentTrackingShipmentRequestSegment,
  shipmentTrackingSubcontractorOrderSegment,
  spOfferRequestSegment,
  spOfferRequestStatusSegment,
  spOfferRequestUpdatedSegment,
  timelineSegment,
  timelineUpdatedSegment
} from './delivery-websocket-topic-url-constants';

export const offerRequestStatusUpdatedTopicUrl = (offerRequestUuid: any) => `/${subscribeSegment}/${offerRequestSegment}/${offerRequestUuid}/${offerRequestStatusSegment}/${offerRequestUpdatedSegment}`;

export const offerAddedTopicUrl = (offerRequestUuid: any) => `/${subscribeSegment}/${offerSegment}/${offerAddedSegment}/${offerRequestUuid}`;

export const spOfferRequestStatusUpdatedTopicUrl = (offerRequestUuid: any) => `/${subscribeSegment}/${spOfferRequestSegment}/${offerRequestUuid}/${spOfferRequestStatusSegment}/${spOfferRequestUpdatedSegment}`;

export const orderStatusUpdatedTopicUrl = (orderUuid: any) => `/${subscribeSegment}/${orderSegment}/${orderUuid}/${orderStatusSegment}/${orderUpdatedSegment}`;

export const sendOfferChatMessageTopicUrl = (threadUuid: any) => `/${sendSegment}/${offerChatSegment}/${offerChatSendMessageSegment}/${threadUuid}`;
export const sendOfferChatReadMessageTopicUrl = (threadUuid: any) => `/${sendSegment}/${offerChatSegment}/${offerChatReadMessageSegment}/${threadUuid}`;
export const offerChatMessagesTopicUrl = (threadUuid: any) => `/${subscribeSegment}/${offerChatSegment}/${threadUuid}`;
export const offerChatStatusUpdatedTopicUrl = (threadUuid: any) => `/${subscribeSegment}/${offerChatSegment}/${threadUuid}/${offerChatStatusSegment}/${offerChatStatusUpdateSegment}`;
export const offerChatIncomingMessageTopicUrl = (offerUuid: any, currentUserOwner: any) => `/${subscribeSegment}/${offerChatSegment}/${offerChatIncomingSegment}/${offerUuid}/${currentUserOwner}`;

export const shipmentSplitOfferAddedTopicUrl =  (shipmentGroupUuid: any) => `/${userSubscribeSegment}/${shipmentSplitSegment}/${shipmentSplitOfferSegment}/${shipmentSplitAddedSegment}/${shipmentGroupUuid}`;

export const shipmentTrackingShipmentRequestSavedTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingShipmentRequestSegment}/${shipmentTrackingSavedSegment}`;
export const shipmentTrackingOrderSavedTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingOrderSegment}/${shipmentTrackingSavedSegment}`;
export const shipmentTrackingSubcontractorOrderSavedTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingSubcontractorOrderSegment}/${shipmentTrackingSavedSegment}`;
export const shipmentTrackingOrderStatusUpdatedAcceptedTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingOrderSegment}/${shipmentTrackingOrderStatusUpdatedSegment}/${shipmentTrackingOrderStatusAcceptedSegment}`;
export const shipmentTrackingOrderStatusUpdatedInProgressTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingOrderSegment}/${shipmentTrackingOrderStatusUpdatedSegment}/${shipmentTrackingOrderStatusInProgressSegment}`;
export const shipmentTrackingOrderStatusUpdatedInTransitTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingOrderSegment}/${shipmentTrackingOrderStatusUpdatedSegment}/${shipmentTrackingOrderStatusInTransitSegment}`;
export const shipmentTrackingOrderStatusUpdatedCompletedTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingOrderSegment}/${shipmentTrackingOrderStatusUpdatedSegment}/${shipmentTrackingOrderStatusCompletedSegment}`;
export const shipmentTrackingOrderStatusUpdatedDocumentsReceivedTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingOrderSegment}/${shipmentTrackingOrderStatusUpdatedSegment}/${shipmentTrackingOrderStatusDocumentsReceivedSegment}`;
export const shipmentTrackingSubcontractorOrderStatusUpdatedAcceptedTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingSubcontractorOrderSegment}/${shipmentTrackingOrderStatusUpdatedSegment}/${shipmentTrackingOrderStatusAcceptedSegment}`;
export const shipmentTrackingSubcontractorOrderStatusUpdatedInProgressTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingSubcontractorOrderSegment}/${shipmentTrackingOrderStatusUpdatedSegment}/${shipmentTrackingOrderStatusInProgressSegment}`;
export const shipmentTrackingSubcontractorOrderStatusUpdatedInTransitTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingSubcontractorOrderSegment}/${shipmentTrackingOrderStatusUpdatedSegment}/${shipmentTrackingOrderStatusInTransitSegment}`;
export const shipmentTrackingSubcontractorOrderStatusUpdatedCompletedTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingSubcontractorOrderSegment}/${shipmentTrackingOrderStatusUpdatedSegment}/${shipmentTrackingOrderStatusCompletedSegment}`;
export const shipmentTrackingOrderInvoiceGeneratedTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingOrderSegment}/${shipmentTrackingInvoiceSegment}/${shipmentTrackingGeneratedSegment}`;
export const shipmentTrackingOrderClosedTopicUrl = `/${userSubscribeSegment}/${shipmentTrackingSegment}/${shipmentTrackingOrderSegment}/${shipmentTrackingClosedSegment}`;

export const deliveryInboxItemAddedTopicUrl = `/${userSubscribeSegment}/${deliveryInboxSegment}/${deliveryInboxAddedSegment}`;
export const deliveryInboxItemUpdatedTopicUrl = `/${userSubscribeSegment}/${deliveryInboxSegment}/${deliveryInboxUpdatedSegment}`;
export const deliveryOutboxItemUpdatedTopicUrl = `/${userSubscribeSegment}/${deliveryOutboxSegment}/${deliveryOutboxUpdatedSegment}`;

export const shipmentTimelineUpdatedTopicUrl = (timelineUuid: any) => `/${subscribeSegment}/${timelineSegment}/${timelineUpdatedSegment}/${timelineUuid}`;

